module.exports = __webpack_public_path__ + "static/media/79.d9cf84ca.png";